<template>
	<!-- wx8cc679d5716ba155是移动应用（电巢app）的appid，一个公众号只能绑定一个（只绑定了生产环境域名） -->
	<wx-open-launch-app 
	appid="wx8cc679d5716ba155" 
	class="outWrapper" 
	:extinfo="extinfo"
	@click.stop="handleClick"
	@error="error" 
	>
		<script type="text/wxtag-template">
			<style>.wxTag { position: absolute; top: 0; right: 0; bottom: 0; left: 0;}</style>
			<div class="wxTag"></div>
		</script>
  </wx-open-launch-app>
</template>

<script>
	import Vue from 'vue'
	import utils from '@/utils/utils'
	import http, {appId} from '@/utils/http'
	import wx from '@/utils/jweixin1.6.0.js'
	import OpenInBrowserMask from '@/components/OpenInBrowserMask'

	export default {
		props: ["extinfo"],
		data(){
			return {
				isIOS: utils.browserChecker.isIOS()
			}
		},
		methods: {
			/*每一个url至少需要调用一次（也仅需调用一次）*/
			register(){
				if(!this.isIOS && (utils.browserChecker.isWx() || utils.browserChecker.isMobileQQ())){
					http.get('/user/getShareSign', {
						params: {
							appid: appId,  /*巢粉俱乐部*/
							url: encodeURIComponent(window.location.href.split('#')[0])
						}
					}).then(res => {
						let data = res.data || {}
						wx.config({
							debug: false,
							appId: appId,
							timestamp: data.timestamp,
							nonceStr: data.noncestr,
							signature: data.signature,
							jsApiList: ['checkJsApi'],
							openTagList: ['wx-open-launch-app']
						})
						wx.error(() => {
							console.log('配置失败')
						})
					})
				}
			},
			handleClick(){
				if(!utils.browserChecker.isWx() || this.isIOS){
					utils.callNativeApp(encodeURIComponent(this.extinfo))
				}
			},
			showOpenInBrowser(){
				const vm = new Vue({
					render: h => h(OpenInBrowserMask)
				}).$mount()
				let comp = vm.$children[0]
				document.body.appendChild(comp.$el)
				comp.remove = () => {
					document.body.removeChild(comp.$el)
					vm.$destroy()
				}
				comp.show()
			},
			error(e){
				let errDetail = e.detail
				if(errDetail.errMsg === 'launch:fail'){
					if(utils.browserChecker.isAndroid()){
						location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.eda365.elecnest.an&android_schema=' + encodeURIComponent('elecnest://' + this.extinfo)
					}else if(utils.browserChecker.isIOS()){
						utils.callNativeApp(encodeURIComponent(this.extinfo))
					}
				}
			}
		}
	}
</script>

<style scoped>
.outWrapper{
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 1;
}
</style>